/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Filetoggle_Arialabel4Inputs */

const en_coinvestments_dataroom_filetoggle_arialabel4 = /** @type {(inputs: Coinvestments_Dataroom_Filetoggle_Arialabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow download`)
};

/**
* | output |
* | --- |
* | "Allow download" |
*
* @param {Coinvestments_Dataroom_Filetoggle_Arialabel4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_filetoggle_arialabel4 = /** @type {((inputs?: Coinvestments_Dataroom_Filetoggle_Arialabel4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Filetoggle_Arialabel4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_filetoggle_arialabel4(inputs)
});
export { coinvestments_dataroom_filetoggle_arialabel4 as "coInvestments_dataRoom_fileToggle_ariaLabel" }